import { CheckCircle2, Loader2, XCircle } from 'lucide-react'
import type { StepStatus } from '@/services/api/playground'

export interface StepView {
  step: string
  status: StepStatus
  duration_ms?: number
}

const STEP_LABELS: Record<string, string> = {
  extract_text: 'Extract text',
  chunk: 'Chunk',
  analyze: 'Analyze',
  extract_entities: 'Extract entities',
  validate: 'Validate',
}

function label(step: string): string {
  return STEP_LABELS[step] ?? step
}

export function StepStrip({ steps }: { steps: StepView[] }) {
  if (steps.length === 0) return null
  return (
    <div className="flex flex-wrap items-center gap-2">
      {steps.map(s => (
        <div
          key={s.step}
          className="flex items-center gap-1.5 rounded-md border border-border bg-muted/50 px-2 py-1 text-xs text-foreground"
        >
          {s.status === 'started' && <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" />}
          {s.status === 'finished' && <CheckCircle2 className="h-3.5 w-3.5 text-primary" />}
          {s.status === 'failed' && <XCircle className="h-3.5 w-3.5 text-destructive" />}
          <span>{label(s.step)}</span>
          {s.status === 'finished' && s.duration_ms != null && (
            <span className="text-muted-foreground">{s.duration_ms} ms</span>
          )}
        </div>
      ))}
    </div>
  )
}
